import { useLocation, useNavigate, useParams } from 'react-router-dom'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useEffect } from 'modules/core/hooks/useEffect'
import { useLazyRef } from 'modules/core/hooks/useLazyRef'
import { useNavigation } from 'modules/core/hooks/useNavigation'
import { track, trackingEvents } from 'modules/core/lib/Tracking'
import i18n from 'modules/core/lib/i18n'

import {
  ResponsivePage,
  ResponsivePageActionsInterface,
} from 'modules/layout/components/ResponsivePage'
import { Content } from 'modules/marketplace/components/Item'
import { locale } from 'modules/marketplace/components/utils/locales'
import { useGetMarketplaceIntegrations } from 'modules/marketplace/hooks/integrations/useGetMarketplaceIntegrations'
import { useShowIntegrationSettings } from 'modules/marketplace/hooks/integrations/useShowIntegrationSettings'

import {
  CompanyInstallations,
  CompanyInstallationsProvider,
} from '../store/collections/companyInstallations'

const ItemPage = () => {
  const navigate = useNavigate()
  const { navigation } = useNavigation()
  const companyInstallationCollection = useLazyRef(() => new CompanyInstallations()).current
  const {
    access: { locale: user_locale },
    company,
  } = useCurrentSession()
  const datoFormatLocale = locale[user_locale]
  const { id } = useParams()
  const location = useLocation()
  const queryParams = new URLSearchParams(location.search)

  const { data: integrationsData, loading: loadingIntegrations } = useGetMarketplaceIntegrations({
    datoIds: [id || '-1'],
    locale: datoFormatLocale,
  })

  const integration = integrationsData.at(0)
  // REMOVE this once FactorialOne Layout is enabled for all companies
  const showSettingsButton = useShowIntegrationSettings(integration)

  useEffect(() => {
    integration?.datoId &&
      integration?.name &&
      track(trackingEvents.marketplace.visitMarketplaceIntegrationItem, {
        integrationId: integration.datoId,
        integrationName: integration.name,
        source: queryParams.get('from'),
        industry: company.industry,
        numberOfSeats: company.subscription.seatCount,
        market: company.legalEntities.find((legalEntity) => legalEntity.main)?.country,
      })
  }, [integration?.datoId])

  // REMOVE this once FactorialOne Layout is enabled for all companies
  const responsiveActionButtons: ResponsivePageActionsInterface = {
    primary: [
      {
        label: i18n.t('marketplace.integrations.settings'),
        variant: 'primary',
        icon: 'settings',
        onClick: () =>
          navigate(
            navigation.discover.marketplace.item.settings.fullPath({
              id: integration?.datoId || '-1',
            })
          ),
      },
    ],
  }

  return (
    <CompanyInstallationsProvider collection={companyInstallationCollection}>
      <ResponsivePage.Body
        showHeader={false}
        actions={showSettingsButton ? responsiveActionButtons : undefined}
        loading={loadingIntegrations}
        error={!integration}
      >
        <Content />
      </ResponsivePage.Body>
    </CompanyInstallationsProvider>
  )
}

export default ItemPage
